import { CandidateColumns } from '../table/CandidateColumns';

/**
 * Valida che le colonne etichetta siano presenti tra le colonne della tabella
 */
export const validateLabelColumns = (
  labelFieldColumns: string[] | undefined,
  columns: string[] | undefined,
) => {
  if (!labelFieldColumns?.length) return { isValid: true };

  const invalidColumns = labelFieldColumns.filter(col => !columns?.includes(col));

  if (invalidColumns.length > 0) {
    const invalidColumnLabels = invalidColumns
      .map(colName => {
        const column = CandidateColumns.find(col => col.name === colName);
        return column?.label || colName;
      })
      .join('", "');

    const message = invalidColumns.length === 1 
      ? `La colonna "${invalidColumnLabels}" non è presente tra le colonne visualizzate nella tabella.`
      : `Le colonne "${invalidColumnLabels}" non sono presenti tra le colonne visualizzate nella tabella.`;

    return {
      isValid: false,
      message,
    };
  }

  return { isValid: true };
};
